module.exports = "<div *ngIf=\"errorMessage !== null\" class=\"control-message__box\"><span class=\"control-message__text\">{{errorMessage}}</span></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/control-messages/control-messages.html
// module id = JOGe
// module chunks = 12